import { breakpoint } from '@/helpers/BreakpointHelper';
import React from 'react';
import { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

export const BANNER_DISP_LOC_CD__DONATE_S1 = 'donor_step_1';
export const BANNER_DISP_LOC_CD__DONATE_S2 = 'donor_step_2';
export const BANNER_DISP_LOC_CD__DONATE_S3 = 'donor_step_3';

const DonateBannerFonts = createGlobalStyle`
  @font-face {
    font-family: 'Jalnan Gothic';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_231029@1.1/JalnanGothic.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/woff2/Pretendard-SemiBold.woff2') format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
`;

export interface BannerInfoData {
  indexNumber: string;
  supportModuleCode?: string; // 후원모듈배너
  scIndexNumber?: string; // 후원코드배너
  bnMessage: string;
  attGrpNoPcBanner: string;
  attGrpNoMoBanner: string;
  attGrpNoPcBannerFullpath: string;
  attGrpNoMoBannerFullpath: string;
  bnDispLoc: string;
}
interface DonateBannerProps {
  bannerinfo?: BannerInfoData;
  summaryText?: string | null;
  children?: JSX.Element | JSX.Element[];
}

const DonateBannerContainer = styled.div`
  width: 384px;
  min-height: 80px;
  background-color: #e8ecef;
  margin-left: auto;
  padding: 10px 14px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: #1cabe2;
  line-height: 1.3;

  .step2_img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: right top;
    position: absolute;
    top: 0;
    right: 0;
    &.mobile {
      display: none;
    }
  }

  span {
    position: relative;
    z-index: 2;
  }

  .banner-message {
    font-family: 'Jalnan Gothic', sans-serif;
    font-weight: 400;
    color: #000;
  }

  .banner-summary {
    display: block;
    font-family: 'Pretendard', sans-serif;
    font-size: 12px;
    font-weight: 600;
    margin-top: 2px;
  }

  ${breakpoint(`mobile`)} {
    width: 15.2rem;
    height: 60px;
    span {
      font-size: 13px;
    }
    .banner-summary {
      font-size: 11px;
    }
    .step2_img {
      &.pc {
        display: none;
      }
      &.mobile {
        display: block;
      }
    }
  }
`;

const DonateBanner: FC<DonateBannerProps> = React.memo(
  ({ bannerinfo, summaryText }, key) => {
    return (
      <>
        <DonateBannerFonts />
        {bannerinfo?.bnMessage && (
          <DonateBannerContainer key={`bn-${key}`}>
            <span className="banner-message">
              {bannerinfo.bnMessage.split('\\n').map((line, idx) => {
                return (
                  <span key={idx}>
                    {line}
                    <br />
                  </span>
                );
              })}
            </span>
            {summaryText && (
              <span className="banner-summary">{summaryText}</span>
            )}
            <img
              src={bannerinfo.attGrpNoPcBannerFullpath}
              alt=""
              className="step2_img pc"
            />
            <img
              src={bannerinfo.attGrpNoMoBannerFullpath}
              alt=""
              className="step2_img mobile"
            />
          </DonateBannerContainer>
        )}
      </>
    );
  },
);

export default DonateBanner;
